'use client';

import { useState } from 'react';
import { cn } from '@/app/_lib/utils';
import Logo from './logo/logo';
import Navbar from './navbar/navbar';
import type { HeaderComponentProps } from './header.types';

export default function HeaderComponent({
  logoHref = '/',
  pages,
  currentPath,
  languages = [],
  variant,
  showLanguageSwitcher = true,
  actionButton,
  mobileMenuSlidePosition = 'left',
}: HeaderComponentProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // Compute tokenized header classes
  const getDefaultHeaderClasses = () => 'w-full';

  const getDesignTokenHeaderClasses = () =>
    'bg-navbar-main-background shadow-navbar-shadow-ext backdrop-blur-navbar-blur-ext py-navbar-ext-padding-y-mobile lg:py-navbar-ext-padding-y-desktop';

  const getHeaderClasses = () => {
    return cn(getDefaultHeaderClasses(), getDesignTokenHeaderClasses());
  };

  // Compute tokenized header inner classes
  const getDesignTokenHeaderInnerClasses = () =>
    'px-navbar-ext-padding-x-mobile xl:px-navbar-ext-padding-x-desktop';

  const getDefaultHeaderInnerClasses = () => 'container xl:max-w-7xl mx-auto';

  const getHeaderInnerClasses = () => {
    return cn(
      getDefaultHeaderInnerClasses(),
      getDesignTokenHeaderInnerClasses()
    );
  };

  // Compute tokenized navbar classes
  const getDefaultNavbarClasses = () =>
    "grid grid-cols-[auto_1fr] relative isolate before:content-[''] before:absolute before:inset-0 before:z-behind";

  /*before: backdrop-filter-[var(--navbar-blur-int,none)]*/
  const getDesignTokenNavbarClasses = () =>
    'py-navbar-int-padding-y-mobile lg:py-navbar-int-padding-y-desktop pl-navbar-int-padding-x-left-mobile pr-navbar-int-padding-x-right-mobile xl:pl-navbar-int-padding-x-left-desktop lg:pr-navbar-int-padding-x-right-desktop before:rounded-navbar-internal-radius before:backdrop-blur-navbar-blur-int before:bg-navbar-int-background rounded-navbar-internal-radius shadow-navbar-shadow-int-mobile lg:shadow-navbar-shadow-int-desktop';

  const getNavbarClasses = () => {
    return cn(getDefaultNavbarClasses(), getDesignTokenNavbarClasses());
  };

  return (
    <div className={cn(getHeaderClasses(), mobileMenuOpen && 'invisible')}>
      <div className={getHeaderInnerClasses()}>
        <div className={getNavbarClasses()}>
          <Logo
            href={logoHref}
            className="w-logo-width-sm lg:w-logo-width-lg"
          />

          <Navbar
            pages={pages}
            currentPath={currentPath}
            languages={languages}
            variant={variant}
            actionButton={actionButton}
            showLanguageSwitcher={showLanguageSwitcher}
            mobileMenuSlidePosition={mobileMenuSlidePosition}
            mobileMenuOpen={mobileMenuOpen}
            onMobileMenuOpenChange={setMobileMenuOpen}
          />
        </div>
      </div>
    </div>
  );
}

export { HeaderComponent };
